import React from 'react';
import styled from 'styled-components';
import TransactionItem from './TransactionItem';
import LoadingState from '#app/components/LoadingState/LoadingState';
import EmptyState from '#app/components/EmptyState/EmptyState';

const TransactionsListContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const TransactionsSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
`;

const TransactionSubTitle = styled.div`
  font-weight: 400;
  font-size: 14px;
  color: #7f818d;
  margin-bottom: 16px;
`;

export interface Transaction {
  id: string;
  title: string;
  date: string;
  amount: string;
  change?: string;
  type: 'income' | 'outcome';
  currency?: string;
  description?: string;
}

interface Props {
  transactions?: Transaction[];
  titleSection?: string;
  emptyState?: React.ReactNode;
  highlightedId?: string | number | null;
  isLoading?: boolean;
}

const TransactionList: React.FC<Props> = ({
  transactions = [],
  titleSection = '',
  emptyState = null,
  highlightedId = null,
  isLoading = false,
}) => {
  if (isLoading) {
    return (
      <TransactionsSection>
        {titleSection && <TransactionSubTitle>{titleSection}</TransactionSubTitle>}
        <LoadingState style={{ minHeight: 200 }} />
      </TransactionsSection>
    );
  }

  if (!transactions || transactions.length === 0) {
    return (
      <TransactionsSection>
        {titleSection && <TransactionSubTitle>{titleSection}</TransactionSubTitle>}
        {emptyState || <EmptyState message="Нет транзакций" />}
      </TransactionsSection>
    );
  }

  return (
    <TransactionsSection>
      {titleSection && <TransactionSubTitle>{titleSection}</TransactionSubTitle>}
      <TransactionsListContainer>
        {transactions.map((transaction) => (
          <TransactionItem
            key={transaction.id}
            {...transaction}
            isHighlighted={highlightedId === transaction.id}
          />
        ))}
      </TransactionsListContainer>
    </TransactionsSection>
  );
};

export default TransactionList;
